// Redux actions for project IFC model CRUD (multipart upload of .ifc files).
import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => jsonFormData({ project_ifc_model: data }, { showLeafArrayIndexes: false });

const UPLOAD_TIMEOUT = 3000000;

export const GET_PROJECT_IFC_MODELS = "get_project_ifc_models";
export const getProjectIfcModels = (project_id) => {
  const url = `/project/${project_id}/ifc_models.json`;
  const request = axios.get(url);
  return {
    type: GET_PROJECT_IFC_MODELS,
    payload: request,
  };
};

export const CREATE_PROJECT_IFC_MODEL = "create_project_ifc_model";
export const createProjectIfcModel = (project_id, data) => {
  const url = `/project/${project_id}/ifc_models.json`;
  const request = axios({ method: "post", url: url, data: prepareData(data), timeout: UPLOAD_TIMEOUT });
  return {
    type: CREATE_PROJECT_IFC_MODEL,
    payload: request,
  };
};

export const GET_PROJECT_IFC_MODEL = "get_project_ifc_model";
export const getProjectIfcModel = (project_id, id) => {
  const url = `/project/${project_id}/ifc_models/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_PROJECT_IFC_MODEL,
    payload: request,
  };
};

export const UPDATE_PROJECT_IFC_MODEL = "update_project_ifc_model";
export const updateProjectIfcModel = (project_id, id, data) => {
  const url = `/project/${project_id}/ifc_models/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data), timeout: UPLOAD_TIMEOUT });
  return {
    type: UPDATE_PROJECT_IFC_MODEL,
    payload: request,
  };
};

export const DESTROY_PROJECT_IFC_MODEL = "destroy_project_ifc_model";
export const destroyProjectIfcModel = (project_id, id) => {
  const url = `/project/${project_id}/ifc_models/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_PROJECT_IFC_MODEL,
    payload: request,
  };
};
